import ForbiddenPage from "@/components/ui/ForbiddenPage/ForbiddenPage";
import React from "react";

import { useGates } from "..";

import useShouldWait from "./useShouldWait";

export default function CanAllGuard({ gates = [], doNothingOnDisable, children, ...rest }) {
  const { canAll } = useGates(rest);
  const onDisableComponent = doNothingOnDisable ? <></> : <ForbiddenPage />;
  return useShouldWait() ? <></> : canAll(gates) ? children : onDisableComponent;
}
